<form class="filter-panel" [formGroup]="filterForm">
  <div class="filter-header">
    <span class="title">Filter Opportunities</span>
    <button appButton border type="button" (click)="clearSearchFilters()">Clear</button>
    <button appButton border type="button" [accent]="showAll" (click)="onShowAll()">
      Show All
    </button>
  </div>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Account Name</mat-label>
    <input
      type="text"
      matInput
      formControlName="accountName"
      [placeholder]="minSearchLength + '+ characters'"
      [matAutocomplete]="accountNameAuto"
      (focus)="onAccountNameFocus()"
    />
    <mat-autocomplete #accountNameAuto="matAutocomplete">
      @for (option of accountNameSuggestions ?? []; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Opportunity Name</mat-label>
    <input
      type="text"
      matInput
      formControlName="opportunityName"
      [placeholder]="minSearchLength + '+ characters'"
    />
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Stage</mat-label>
    <mat-select formControlName="opportunityStage">
      <mat-option value="">All</mat-option>
      @for (option of filterOptions?.opportunityStages ?? []; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Business Unit</mat-label>
    <mat-select formControlName="opportunityBU">
      <mat-option value="">All</mat-option>
      @for (option of filterOptions?.opportunityBUs ?? []; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Class</mat-label>
    <mat-select formControlName="opportunityClass">
      <mat-option value="">All</mat-option>
      @for (option of filterOptions?.opportunityClasses ?? []; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Sub-Class</mat-label>
    <mat-select formControlName="opportunitySubClass">
      <mat-option value="">All</mat-option>
      @for (option of filterOptions?.opportunitySubClasses ?? []; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Risk Type</mat-label>
    <mat-select formControlName="opportunityRiskType">
      <mat-option value="">All</mat-option>
      @for (option of filterOptions?.opportunityRiskTypes ?? []; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Status</mat-label>
    <mat-select formControlName="initiated">
      <mat-option [value]="null">All</mat-option>
      <mat-option [value]="false">Not initiated</mat-option>
      <mat-option [value]="true">Initiated</mat-option>
    </mat-select>
  </mat-form-field>
</form>
